import { getType } from "../utils/utilities"
import {getSingletonInstance} from "../services/singleton-cache"

/**
 * Singleton class generator and cache container. If you need a specific version use @NewInstance.
 *
 * @param target - target class.
 * @param key - field name.
 */
export default function Singleton(target: any, key: string): any {
    const type: any = getType(target, key)
    const singleton: any = new type()

    target[key] = getSingletonInstance(singleton)
}